export default "/images/Device_sgp4.png?2f30d4a66c7b326da9f20ae8bd9a117e";